import React from 'react';
import useSubscriptionDetail from '@root/hooks/subscription/useDetail';
import PageLoading from '@root/components/PageLoading';
import PageLoadError from '@root/components/PageLoadError';
import Button from '@root/components/Button';
import DetailContent from './DetailContent';
import './index.less';
import Empty from '@root/components/Empty';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const SubscriptionDetail = () => {
  const { t } = useTranslation();
  const data = useSubscriptionDetail();
  const { detail, loading, getDetail } = data;

  if (loading === 0) {
    return <PageLoading />;
  }

  if (loading === 2) {
    return <PageLoadError onTryAgain={getDetail} />;
  }

  if (detail.isExpire === 1) {
    return (
      <Empty marginTop={20}>
        {t('invalid_service')}
        <div className="empty-container-btn">
          <Link to="/">
            <Button>{t('ok')}</Button>
          </Link>
        </div>
      </Empty>
    );
  }

  return <DetailContent data={data} />;
};

export default SubscriptionDetail;
